import Axios from '../configs/Axios';

export type VersionData = {
  hash: string;
};

export const getVersion = async (): Promise<VersionData> => {
  const response = await Axios.get<VersionData>(
    `${process.env.PUBLIC_URL}/version.json?t=${Date.now()}`,
    {
      baseURL: window.location.origin,
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    },
  );

  return response.data;
};
